import { FC, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useCmNetworkPoint } from 'src/apis/capacity-management/use-cm-network-point';
import AddInternalBooking from 'src/pages/transport/network-points/details/availability-and-price-data/internal-bookings/add';
import EditInternalBooking from 'src/pages/transport/network-points/details/availability-and-price-data/internal-bookings/edit';
import Overview from 'src/pages/transport/network-points/details/availability-and-price-data/overview';
import EditPriceSettings from 'src/pages/transport/network-points/details/availability-and-price-data/price-settings/edit';
import EditPriceSteps from 'src/pages/transport/network-points/details/availability-and-price-data/price-steps/edit';
import EditTechnicalCapacity from 'src/pages/transport/network-points/details/availability-and-price-data/technical-capacity/edit';
import { NetworkPointRequest } from 'src/pages/transport/network-points/details/use-network-point';

const NotFound = lazy(() => import('../../../../errors/not-found'));

type Props = {
  networkPoint: NetworkPointRequest;
  capacityManagementRoot: CapacityManagementRootRequest;
};

export const AvailabilityAndPriceData: FC<Props> = ({
  networkPoint,
  capacityManagementRoot,
}) => {
  const cmNetworkPoint = useCmNetworkPoint({
    capacityManagementRoot,
    networkPoint,
  });

  return (
    <Switch>
      <Route
        path="/transport/network-points/:oldNetworkPointId/availability-and-price-data"
        exact
      >
        <Overview
          networkPoint={networkPoint}
          capacityManagementRoot={capacityManagementRoot}
          cmNetworkPoint={cmNetworkPoint}
        />
      </Route>

      <Route
        path="/transport/network-points/:oldNetworkPointId/availability-and-price-data/technical-capacity/edit"
        exact
      >
        <EditTechnicalCapacity cmNetworkPoint={cmNetworkPoint} />
      </Route>

      <Route
        path="/transport/network-points/:oldNetworkPointId/availability-and-price-data/internal-bookings/add"
        exact
      >
        <AddInternalBooking cmNetworkPoint={cmNetworkPoint} />
      </Route>

      <Route
        path="/transport/network-points/:oldNetworkPointId/availability-and-price-data/internal-bookings/:bookingId/edit"
        exact
      >
        <EditInternalBooking cmNetworkPoint={cmNetworkPoint} />
      </Route>

      <Route
        path="/transport/network-points/:oldNetworkPointId/availability-and-price-data/price-settings/edit"
        exact
      >
        <EditPriceSettings cmNetworkPoint={cmNetworkPoint} />
      </Route>

      <Route
        path="/transport/network-points/:oldNetworkPointId/availability-and-price-data/price-steps/edit"
        exact
      >
        <EditPriceSteps cmNetworkPoint={cmNetworkPoint} />
      </Route>

      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
};
